import {Card, Stack, Typography} from '@mui/material';
import React from 'react';

import {formatText} from 'presentation/utils/formatText';
import {ServicePointHours} from '../ServicePointHours';
import {ServicePointCardProps} from './types';

import {ServicePointAddress} from '../ServicePointAddress';

export function ServicePointCard({servicePoint}: ServicePointCardProps) {
	return (
		<Card elevation={0} sx={{p: 2, width: '100%', height: '100%'}}>
			<Stack gap={2}>
				<Typography variant="subtitle1" fontWeight={600} lineHeight={1}>
					{formatText(servicePoint.nmCidade)}
				</Typography>

				<ServicePointAddress servicePoint={servicePoint} />
				{servicePoint.horarios?.length ? (
					<ServicePointHours hours={servicePoint.horarios} />
				) : null}
			</Stack>
		</Card>
	);
}
